// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.dialog-heading {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  padding: 14px 24px 12px;
}

.dialog-heading__eyebrow {
  color: var(--primary);
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
}

.dialog-heading h2[mat-dialog-title] {
  background: transparent;
  line-height: 1.15;
  margin: 2px 0 0;
  min-height: 0;
  padding: 0;
}

.record-context {
  align-items: center;
  background: #f5f7f8;
  border-left: 3px solid var(--primary);
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
  padding: 10px 12px;
}

.record-context span {
  color: var(--secondary);
  font-size: 0.8rem;
  font-weight: 700;
}

.edit-form {
  display: grid;
  gap: 14px;
}

.calibration-fields {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.calibration-field {
  border: 1px solid #dee2e6;
  padding: 14px;
}

.calibration-field--new-row {
  grid-column-start: 1;
}

.calibration-field mat-form-field, .notes-field {
  width: 100%;
}

.field-heading {
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.field-heading span {
  color: var(--primary);
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
}

.calibration-field p {
  color: var(--secondary);
  font-size: 0.8rem;
  margin: 5px 0 10px;
}

.numeric-value-field {
  transition: background-color 0.15s ease;
}

.numeric-value-field--target {
  --mdc-outlined-text-field-focus-outline-color: #2f855a;
  --mdc-outlined-text-field-hover-outline-color: #2f855a;
  --mdc-outlined-text-field-outline-color: #68a980;
}

.numeric-value-field--range {
  --mdc-outlined-text-field-focus-outline-color: #2879a8;
  --mdc-outlined-text-field-hover-outline-color: #2879a8;
  --mdc-outlined-text-field-outline-color: #6ca6c7;
}

.numeric-value-field--outside {
  --mdc-outlined-text-field-focus-outline-color: #b42318;
  --mdc-outlined-text-field-hover-outline-color: #b42318;
  --mdc-outlined-text-field-outline-color: #d66b63;
}

:host ::ng-deep .numeric-value-field--target .mat-mdc-text-field-wrapper {
  background: #edf8f1;
}

:host ::ng-deep .numeric-value-field--range .mat-mdc-text-field-wrapper {
  background: #eef6fb;
}

:host ::ng-deep .numeric-value-field--outside .mat-mdc-text-field-wrapper {
  background: #fff1f0;
}

mat-radio-group {
  display: flex;
  gap: 20px;
  padding: 12px 0;
}

.error-message {
  background: #fff1f0;
  border-left: 3px solid var(--danger);
  color: #8a1c1c;
  padding: 10px 12px;
}

mat-dialog-actions {
  border-top: 1px solid #dee2e6;
  gap: 8px;
  padding: 14px 24px 20px;
}

@media (max-width: 700px) {
  .calibration-fields {
    grid-template-columns: 1fr;
  }
  .record-context {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-equipment/calibration-record-edit-dialog.component.scss"],"names":[],"mappings":"AAAA;EAAQ,cAAA;AAER;;AADA;EAAkB,mBAAA;EAAqB,gBAAA;EAAkB,gCAAA;EAAkC,aAAA;EAAe,8BAAA;EAAgC,uBAAA;AAU1I;;AATA;EAA2B,qBAAA;EAAuB,cAAA;EAAgB,iBAAA;EAAkB,gBAAA;EAAkB,yBAAA;AAiBtG;;AAhBA;EAAuC,uBAAA;EAAyB,iBAAA;EAAmB,eAAA;EAAiB,aAAA;EAAe,UAAA;AAwBnH;;AAvBA;EAAkB,mBAAA;EAAqB,mBAAA;EAAqB,qCAAA;EAAuC,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,kBAAA;AAiCvK;;AAhCA;EAAuB,uBAAA;EAAyB,iBAAA;EAAkB,gBAAA;AAsClE;;AArCA;EAAa,aAAA;EAAe,SAAA;AA0C5B;;AAzCA;EAAsB,aAAA;EAAe,SAAA;EAAW,gDAAA;AA+ChD;;AA9CA;EAAqB,yBAAA;EAA2B,aAAA;AAmDhD;;AAlDA;EAA8B,oBAAA;AAsD9B;;AArDA;EAAkD,WAAA;AAyDlD;;AAxDA;EAAiB,aAAA;EAAe,SAAA;EAAW,8BAAA;AA8D3C;;AA7DA;EAAsB,qBAAA;EAAuB,iBAAA;EAAkB,gBAAA;EAAkB,yBAAA;AAoEjF;;AAnEA;EAAuB,uBAAA;EAAyB,iBAAA;EAAkB,kBAAA;AAyElE;;AAxEA;EAAuB,uCAAA;AA4EvB;;AA3EA;EACE,sDAAA;EACA,sDAAA;EACA,gDAAA;AA8EF;;AA5EA;EACE,sDAAA;EACA,sDAAA;EACA,gDAAA;AA+EF;;AA7EA;EACE,sDAAA;EACA,sDAAA;EACA,gDAAA;AAgFF;;AA9EA;EAA2E,mBAAA;AAkF3E;;AAjFA;EAA0E,mBAAA;AAqF1E;;AApFA;EAA4E,mBAAA;AAwF5E;;AAvFA;EAAkB,aAAA;EAAe,SAAA;EAAW,eAAA;AA6F5C;;AA5FA;EAAiB,mBAAA;EAAqB,oCAAA;EAAsC,cAAA;EAAgB,kBAAA;AAmG5F;;AAlGA;EAAqB,6BAAA;EAA+B,QAAA;EAAU,uBAAA;AAwG9D;;AAvGA;EACE;IAAsB,0BAAA;EA2GtB;EA1GA;IAAkB,uBAAA;IAAyB,sBAAA;IAAwB,QAAA;EA+GnE;AACF","sourcesContent":[":host { display: block; }\n.dialog-heading { align-items: center; background: #fff; border-bottom: 1px solid #dee2e6; display: flex; justify-content: space-between; padding: 14px 24px 12px; }\n.dialog-heading__eyebrow { color: var(--primary); display: block; font-size: .7rem; font-weight: 700; text-transform: uppercase; }\n.dialog-heading h2[mat-dialog-title] { background: transparent; line-height: 1.15; margin: 2px 0 0; min-height: 0; padding: 0; }\n.record-context { align-items: center; background: #f5f7f8; border-left: 3px solid var(--primary); display: flex; justify-content: space-between; margin-bottom: 18px; padding: 10px 12px; }\n.record-context span { color: var(--secondary); font-size: .8rem; font-weight: 700; }\n.edit-form { display: grid; gap: 14px; }\n.calibration-fields { display: grid; gap: 12px; grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.calibration-field { border: 1px solid #dee2e6; padding: 14px; }\n.calibration-field--new-row { grid-column-start: 1; }\n.calibration-field mat-form-field, .notes-field { width: 100%; }\n.field-heading { display: flex; gap: 12px; justify-content: space-between; }\n.field-heading span { color: var(--primary); font-size: .7rem; font-weight: 700; text-transform: uppercase; }\n.calibration-field p { color: var(--secondary); font-size: .8rem; margin: 5px 0 10px; }\n.numeric-value-field { transition: background-color .15s ease; }\n.numeric-value-field--target {\n  --mdc-outlined-text-field-focus-outline-color: #2f855a;\n  --mdc-outlined-text-field-hover-outline-color: #2f855a;\n  --mdc-outlined-text-field-outline-color: #68a980;\n}\n.numeric-value-field--range {\n  --mdc-outlined-text-field-focus-outline-color: #2879a8;\n  --mdc-outlined-text-field-hover-outline-color: #2879a8;\n  --mdc-outlined-text-field-outline-color: #6ca6c7;\n}\n.numeric-value-field--outside {\n  --mdc-outlined-text-field-focus-outline-color: #b42318;\n  --mdc-outlined-text-field-hover-outline-color: #b42318;\n  --mdc-outlined-text-field-outline-color: #d66b63;\n}\n:host ::ng-deep .numeric-value-field--target .mat-mdc-text-field-wrapper { background: #edf8f1; }\n:host ::ng-deep .numeric-value-field--range .mat-mdc-text-field-wrapper { background: #eef6fb; }\n:host ::ng-deep .numeric-value-field--outside .mat-mdc-text-field-wrapper { background: #fff1f0; }\nmat-radio-group { display: flex; gap: 20px; padding: 12px 0; }\n.error-message { background: #fff1f0; border-left: 3px solid var(--danger); color: #8a1c1c; padding: 10px 12px; }\nmat-dialog-actions { border-top: 1px solid #dee2e6; gap: 8px; padding: 14px 24px 20px; }\n@media (max-width: 700px) {\n  .calibration-fields { grid-template-columns: 1fr; }\n  .record-context { align-items: flex-start; flex-direction: column; gap: 4px; }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
